/**
 * Sprint ANA-1 · #16 — Tracking de eventos del marketplace.
 *
 * Fire-and-forget. No bloquea UI. Una session_id por pestaña (sessionStorage)
 * para que el funnel agrupe correctamente sin contaminar entre visitantes.
 *
 * Eventos permitidos: marketplace_view, org_page_view, booking_start,
 * booking_step_advance, booking_submit, booking_payment_success,
 * marketplace_search, marketplace_filter, share_org.
 */
import { api } from "./api";

function getSessionId() {
  const key = "ag-analytics-session";
  try {
    let s = sessionStorage.getItem(key);
    if (!s) {
      s = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(key, s);
    }
    return s;
  } catch {
    return `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
}

export function track(event, { orgSlug, orgId, metadata } = {}) {
  // Fire-and-forget; nunca bloquear UI ni romper render
  try {
    const payload = {
      event,
      org_slug: orgSlug || null,
      org_id: orgId || null,
      session_id: getSessionId(),
      metadata: metadata || {},
    };
    api.post("/analytics/event", payload).catch(() => {});
  } catch {
    // silent
  }
}
